import type { SelectItemType } from "@/shared/components/select/select-shared";
import type { InfractionDriverLookupApiResponse } from "../types/infraction-api.types";

export function mapDriverLookupToSelectItems(
	drivers: InfractionDriverLookupApiResponse[]
): SelectItemType[] {
	return drivers.map((driver) => ({
		id: driver.id,
		label: driver.name ?? "Condutor",
		supportingText: driver.cpf ?? undefined,
	}));
}
